import { InjectionToken } from '@angular/core';
import { ConfigService } from '../models/interceptor.models';
import { of } from 'rxjs';

export const CONFIG_SERVICE = new InjectionToken<ConfigService>('ConfigService', {
  providedIn: 'root',
  factory: () => ({
    getDebugConfig: () => ({
      debugMode: true,
      threshold: 300,
      logTypes: {
        request: true,
        response: true,
        error: true,
        performance: true,
        finalize: false,
      }
    }),
    getAuthAccessToken: () => of(''),
    getRetryConfig: () => ({
      maxRetries: 3,
      initialRetryDelay: 500,
      delayMultiplier: 2,
      retryableStatusCodes: [],
      logRetryAttempts: true,
      logErrors: true,
    }),
    getAuthConfig: () => ({
      debugMode: true,
      securedEndpoints: []
    }),
    getTenantConfig: () => ({
      debugMode: true,
      securedEndpoints: [],
      tenantIdPropertyName: 'tenantId',
      tenantIds: [],
      redirectUrl: '',
    })
  }),
});
